const ARGENTO_SIZES = {
  Bracciali: ['15 cm', '16 cm', '17 cm', '18 cm', '19 cm', '20 cm', '21 cm'],
  Collane: ['42 cm', '50 cm'],
  Anelli: Array.from({ length: 19 }, (_, i) => String(i + 8)),
};

export const getSizeOptions = (product) =>
  product?.collection === 'Argento' ? ARGENTO_SIZES[product.category] || [] : [];
